module.exports = __webpack_public_path__ + "static/assets/dcd4e99c8ddf7634ce04803950b7e266.png";